import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { QuickWinSection } from '../components/QuickWinSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-main font-sans text-body" data-id="element-225">
      {/* Navigation / Logo */}
      <nav className="absolute top-0 left-0 w-full p-6 z-50" data-id="element-226">
        <div className="max-w-7xl mx-auto flex justify-center items-center" data-id="element-227">
          <div className="text-xl font-serif font-bold tracking-wider text-title" data-id="element-228">
            MÉTODO FACELESS<span className="text-accent" data-id="element-229">.</span>
          </div>
        </div>
      </nav>

      <main data-id="element-230">
        <HeroSection data-id="element-231" />
        <ProblemSection data-id="element-232" />
        <SolutionSection data-id="element-233" />
        <WhatInsideSection data-id="element-234" />
        <QuickWinSection data-id="element-235" />
        <TestimonialsSection data-id="element-236" />
        <PricingSection data-id="element-237" />
        <FAQSection data-id="element-238" />
        <CTASection data-id="element-239" />
      </main>
      <Footer data-id="element-240" />
    </div>;
}